import { useState, useEffect } from "react";
import axios from "axios";
import { Chart as ChartJS, ArcElement, Tooltip, Legend, BarElement, CategoryScale, LinearScale } from "chart.js";
import { Doughnut } from "react-chartjs-2";
import { Bar } from "react-chartjs-2";
import './dashboard.css';
import LoadingSpinner from "../loadspinner/loadspinner";
import { intruderinfo_url } from "../apis";

ChartJS.register(ArcElement, Tooltip, Legend, BarElement, CategoryScale, LinearScale);

function DashboardMain(props) {
  const [caseManagerData, setCaseManagerData] = useState([]);
  const [emptyData, setEmptyData] = useState(false);
  const [loading, setLoading] = useState(false);
  const [riskTrendsChartData, setRiskTrendsChartData] = useState({});
  const [chartData, setChartData] = useState({});
  const [chartData1, setChartData1] = useState({});
  const [chartData2, setChartData2] = useState({});
  const [end_date, setEnd_date] = useState(
    new Date().toJSON().slice(0, 10).toString()
  );
  const [start_date, setStart_date] = useState(
    new Date(new Date().setMonth(new Date().getMonth() - 4))
      .toJSON()
      .slice(0, 10)
      .toString()
  );

  const getCurrentUserToken = () => {
    const currentUser = JSON.parse(localStorage.getItem('currentUser') || '{}');
    return currentUser.token || '';
  }

  var userToken = getCurrentUserToken();
  const headers = {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${userToken}`
  }

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      
      try {
        const params = `&start_date=${props.selected1 == null ? start_date : props.selected1}&end_date=${props.selected2 == null ? end_date : props.selected2}`;
        const response = await axios.get(
          intruderinfo_url + params, { headers }
        );
        const result = response.data;
        const sortedData = [...result.case_manager_data].sort((a, b) => {
          const c = +new Date(a.date);
          const d = +new Date(b.date);
          return d - c;
        });
        setCaseManagerData(sortedData);
        setLoading(false);
        setEmptyData(false);
      } catch (error) {
        if (error.response && error.response.data.message === "No record found") {
          setEmptyData(true);
        }
        if (error.response && error.response.data.msg === "Token has expired") {
          props.onLogout('token');
        }
        setLoading(false);
      }
    };
    fetchData();
  }, [props.selected1, props.selected2]);

  useEffect(() => {
    const calculateChartData = () => {

      const labels = new Set();
      const allMap = new Map();

      caseManagerData.forEach((item) => {
        let date = new Date(item.date);
        let formattedDate =
          date.toLocaleString("en-US", { month: "short" }) +
          " " +
          date.getFullYear();
        labels.add(formattedDate);

        const riskLevel = item.risk_level.toLowerCase();
        if (!allMap.has(formattedDate)) {
          allMap.set(formattedDate, { low: 0, medium: 0, high: 0 });
        }

        let existingCount = allMap.get(formattedDate);
        if (riskLevel === "low") {
          existingCount.low++;
        } else if (riskLevel === "medium") {
          existingCount.medium++;
        } else if (riskLevel === "high") {
          existingCount.high++;
        }
      });

      const allCounts = Array.from(allMap.values());
      const lowCounts = allCounts.map((item) => item.low);
      const mediumCounts = allCounts.map((item) => item.medium);
      const highCounts = allCounts.map((item) => item.high);


      const loginCount = caseManagerData.filter(
        (item) => item.incidence_origination.toLowerCase() === "login"
      ).length;
      const transactionCount = caseManagerData.filter(
        (item) => item.incidence_origination.toLowerCase() === "transaction"
      ).length;
      const FPCount = caseManagerData.filter((item) => item.false_positive.toLocaleLowerCase() === "yes").length;
      const TPCount = caseManagerData.filter((item) => item.false_positive.toLocaleLowerCase() === "no").length;

      const lowCount = caseManagerData.filter((item) => item.risk_level.toLocaleLowerCase() === "low").length;
      const mediumCount = caseManagerData.filter((item) => item.risk_level.toLocaleLowerCase() === "medium").length;
      const highCount = caseManagerData.filter((item) => item.risk_level.toLocaleLowerCase() === "high").length;

      const newChartData = {
        labels: Array.from(labels),
        datasets: [
          {
            data: lowCounts,
            label: "Low",
            backgroundColor: "#A6CEE3",
          },
          {
            data: mediumCounts,
            label: "Medium",
            backgroundColor: "#67C9EE",
          },
          {
            data: highCounts,
            label: "High",
            backgroundColor: "#367085",
          },
        ],
      };

      setRiskTrendsChartData(newChartData);

      setChartData({
        labels: ["Login", "Transaction"],
        datasets: [
          {
            label: "Incident Origination",
            data: [loginCount, transactionCount],
            backgroundColor: ["#67C9EE", "#FF9900"],
            hoverOffset: 4,
          },
        ],
      });

      setChartData1({
        labels: ['True Positive', 'False Positive'],
        datasets: [{
          data: [TPCount, FPCount],
          backgroundColor: ['#367085', '#67C9EE'],
          hoverOffset: 4
        }]
      });

      setChartData2({
        labels: ['Low', 'Medium', 'High'],
        datasets: [{
          data: [lowCount, mediumCount, highCount],
          backgroundColor: ['#A6CEE3', '#67C9EE', '#367085'],
          hoverOffset: 4
        }]
      });
    };

    calculateChartData();
  }, [caseManagerData]);

  return (
    <div className="container mt-2">
       {loading ? (<LoadingSpinner />) : ( emptyData ? <div className="empty-data" style={{ height: "400px" }}><span>No Results Found</span></div> :
        <>
          <div className="row">
            <div className="col-md-6">
              <div className="border p-3 bg-white">
                <div>
                  <p className="mb-3" style={{ borderBottom: '1px solid #E9ECEF' }}>Incident Risk Trends</p>
                </div>
                {caseManagerData.length > 0 ? (
                  <div style={{ width: '100%', height: '180px' }} className="d-flex flex-column justify-content-center align-items-center">
                    <Bar data={riskTrendsChartData}
                      options={
                        {
                          responsive: true,
                          //maintainAspectRatio: false,
                          scales: {
                            x: {
                              grid: {
                                display: false,
                              },
                            },
                            y: {
                              grid: {
                                display: true,
                              },
                              ticks: {
                                suggestedMin: 0,
                                suggestedMax: 1800,
                                stepSize: 200,
                              },
                            },
                          },
                          plugins: {
                            legend: {
                              display: true,
                              position: "top",
                            },
                          },
                        }}
                    />
                  </div>
                ) : (
                  <p></p>
                )}
              </div>
            </div>
            <div className="col-md-6">
              <div className=" border p-3 bg-white">
                <p className="mb-3" style={{ borderBottom: '1px solid #E9ECEF' }}>Incident Origination</p>
                {caseManagerData.length > 0 ? (
                  <div style={{ width: '100%', height: '180px' }} className="d-flex flex-column justify-content-center align-items-center">
                    <Doughnut
                      data={chartData}
                      options={{
                        responsive: false,
                        color: "#495057",
                        plugins: {
                          legend: {
                            position: "right",
                          },
                        },
                      }}
                    />
                  </div>
                ) : (
                  <p></p>
                )}
              </div>
            </div>
          </div>
          <div className="row mt-4">
            <div className="col-md-6">
              <div className=" border p-3 bg-white">
                <p className="mb-3" style={{ borderBottom: '1px solid #E9ECEF' }}>Incident True Positive/ False Positive</p>
                {caseManagerData.length > 0 ? (
                  <div style={{ width: '100%', height: '180px' }} className="d-flex flex-column justify-content-center align-items-center">
                    <Doughnut
                      data={chartData1}
                      options={{
                        responsive: false,
                        color: "#495057",
                        plugins: {
                          legend: {
                            position: "right",
                          },
                        },
                      }}
                    />
                  </div>
                ) : (
                  <p></p>
                )}
              </div>
            </div>
            <div className="col-md-6">
              <div className=" border p-3 bg-white">
                <p className="mb-3" style={{ borderBottom: '1px solid #E9ECEF' }}>Incident Risk Segmentations</p>
                {caseManagerData.length > 0 ? (
                  <div style={{ width: '100%', height: '180px' }} className="d-flex flex-column justify-content-center align-items-center">
                    <Doughnut
                      data={chartData2}
                      options={{
                        responsive: false,
                        color: "#495057",
                        plugins: {
                          legend: {
                            position: "right",
                          },
                        },
                      }}
                    />
                  </div>
                ) : (
                  <p></p>
                )}
              </div>
            </div>
          </div>
        </>
      )}

    </div>
  );
}

export default DashboardMain;
